import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('letsgold-theme');
    return saved ? saved === 'dark' : true; // Default to dark
  });

  useEffect(() => {
    localStorage.setItem('letsgold-theme', isDark ? 'dark' : 'light');
    document.documentElement.classList.toggle('dark', isDark);
  }, [isDark]);

  const toggleTheme = () => setIsDark(!isDark);

  const theme = {
    // Backgrounds
    bg: isDark ? '#0a0a0a' : '#ffffff',
    bgSecondary: isDark ? '#141414' : '#f9fafb',
    bgTertiary: isDark ? '#1a1a1a' : '#f3f4f6',
    bgCard: isDark ? '#141414' : '#ffffff',
    bgHover: isDark ? '#2a2a2a' : '#f3f4f6',
    bgInput: isDark ? '#0a0a0a' : '#ffffff',
    
    // Borders
    border: isDark ? '#2a2a2a' : '#e5e7eb',
    borderLight: isDark ? '#1a1a1a' : '#f3f4f6',
    
    // Text
    text: isDark ? '#ffffff' : '#111827',
    textSecondary: isDark ? '#9ca3af' : '#6b7280',
    textMuted: isDark ? '#6b7280' : '#9ca3af',
    
    // Chart specific
    chartBg: isDark ? '#0a0a0a' : '#ffffff',
    chartGrid: isDark ? '#1a1a1a' : '#e5e7eb',
    chartText: isDark ? '#6b7280' : '#6b7280',
    
    // Tooltip
    tooltipBg: isDark ? '#1a1a1a' : '#ffffff',
    tooltipBorder: isDark ? '#3a3a3a' : '#e5e7eb',
    tooltipText: isDark ? '#ffffff' : '#111827',
  };

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme, theme }}>
      {children}
    </ThemeContext.Provider>
  );
};
